import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { SciencePage } from './pages/SciencePage';
import { ShippingPolicyPage } from './pages/ShippingPolicyPage';
import { JoinPage } from './pages/JoinPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { DistributorPage } from './pages/DistributorPage';
import { WhyChoosePage } from './pages/WhyChoosePage';
import { VitalityPage } from './pages/VitalityPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { ReturnPolicyPage } from './pages/ReturnPolicyPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-1">
        <Header data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/Science.html" element={<SciencePage data-id="element-7" />} data-id="element-6" />
          <Route path="/shipping-policy" element={<ShippingPolicyPage data-id="element-9" />} data-id="element-8" />
          <Route path="/joingnldmembers" element={<JoinPage data-id="element-11" />} data-id="element-10" />
          <Route path="/gnld-Neolife-distributors" element={<DistributorPage data-id="element-13" />} data-id="element-12" />
          <Route path="/contact-us" element={<ContactPage data-id="element-15" />} data-id="element-14" />
          <Route path="/aboutus" element={<AboutPage data-id="element-17" />} data-id="element-16" />
          <Route path="/reviews" element={<ReviewsPage data-id="element-19" />} data-id="element-18" />
          <Route path="/neolife" element={<WhyChoosePage data-id="element-21" />} data-id="element-20" />
          <Route path="/Vitality.html" element={<VitalityPage data-id="element-23" />} data-id="element-22" />
          <Route path="/Privacypolicy.html" element={<PrivacyPolicyPage data-id="element-25" />} data-id="element-24" />
          <Route path="/Returnpolicy.html" element={<ReturnPolicyPage data-id="element-27" />} data-id="element-26" />
        </Routes>
        <Footer data-id="element-28" />
      </div>
    </BrowserRouter>;
}